import Vue from 'vue';
// WebSocket版はポーリング版へ差し替え済み（app/javascript/mentor-chats-notifications-bell.vue）
//import NotificationsBell from './mentor-chats-notifications-bell.vue';
import NotificationsBell from './mentor-chats-notifications-bell-polling.vue';

document.addEventListener('DOMContentLoaded', () => {
  const notificationsBellElement = document.getElementById('js-notifications-bell');
  if (notificationsBellElement) {
    const currentUser = window.currentUser
    new Vue({
      render: h => h(NotificationsBell, {
        props: {
          currentUser: currentUser,
          pagePath: notificationsBellElement.dataset.pagePath,
        }
      })
    }).$mount(notificationsBellElement);
  }
});
